<template>
<!-- Markup -->
  <div id="app"><router-view/></div>
</template>

<script>
//Logic
export default {
  
}
</script>

<style lang="scss">
/** Style */
  @import '~@fortawesome/fontawesome-free/css/all.css';
  @import '~bootstrap/scss/bootstrap.scss';
  @import './assets/css/animate.css';
  @import './assets/css/style.css';
</style>
